import { Location } from '@angular/common';
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { EcomNetworkUtils } from "@src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service";
import { StoreServiceBase } from "@src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase";
import { UserServiceBase } from "@src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase";
import { VoucherBase } from "@src/app/ecom-base-entities/ecom-stores-base/ecom-voucherbase";
import { EComService } from "@src/app/ecom-services/ecom-common.service";
import { EcomCookies } from "@src/app/ecom-services/ecom-cookies";
import { EComGoogleAnalytics } from "@src/app/ecom-services/ecom-google-analytics";
import { EComWebStorage } from "@src/app/ecom-services/ecom-webstorage.services";
import { Base64 } from 'js-base64';

@Component({
    selector: 'app-ecom-promotions',
    templateUrl: './ecom-promotions.component.html',
    styleUrls: ['./ecom-promotions.component.scss']
})
export class EcomPromotionsComponent implements OnInit {
    promos = true;
    vouchers = false;
    vouchersList = [];
    promosList = [];
    promotionType = 'PROMOS';
    promoCodeForm: FormGroup;
    promoError = '';
    userServiceBase: UserServiceBase;
    userSelectedStore: StoreServiceBase;
    locationSelected: any;
    serviceType = '';

    constructor(private eComGoogleAnalytics: EComGoogleAnalytics, public formBuilder: FormBuilder, public location: Location, public ecomservice: EComService, public router: Router,
        private webstorage: EComWebStorage, public cookie: EcomCookies) {

    }
    ngOnInit(): void {
        console.log('ngOnInit');
        let gTag = {
            'event': 'screen_view',
            'screen_name': 'promotions'
        };
        this.eComGoogleAnalytics.customEvent(gTag);
        this.promoCodeForm = this.formBuilder.group({
            promocode: ['', Validators.compose([Validators.required])]
        });
        this.promos = true;
        this.vouchers = false;
        if (this.webstorage.sessionSt_location_selected) {
            var encoded = Base64.encode(this.webstorage.sessionSt_location_selected.oocls_company_id);
            this.location.replaceState(this.location.path(), '?webcompanyid=' + encoded);
        }
        this.getPromos();
        this.getVouchersList();
    }

    getPromos() {
        //let countryCode = this.webstorage.localSt_user_country_code;
        let countryCode = this.cookie.cookie_country_code;
        this.ecomservice.httpGet(EcomNetworkUtils.GET_OLAR_DISCOUNTS_DESCRIPTION + "?countryCode=" + countryCode, '', true).subscribe((response) => {
            if (response['status'] === 403) {
                this.router.navigate(['unauthorized']);
            } else {
                if (response.isSuccess) {
                    this.promosList = response.listValues;
                }
            }
        });
    }

    getVouchersList() {
        this.vouchersList = [];
        this.ecomservice.httpGet(EcomNetworkUtils.GET_VOUCHERSLIST, '', true).subscribe((response) => {
            if (response.isSuccess) {
                for(let voucher of response.listValues) {
                    let obj =  this.vouchersList.some(function(el) {
                        return el.VoucherCode === voucher['VoucherCode'];
                    });
                    if (!obj) {
                        this.vouchersList.push(voucher);
                    }
                }
                console.log(this.vouchersList);
            }
        });
    }

    // Method to handle the back button click
    onBackClick() {
        this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked]);
    }

    onPromotionsClick(type) {
        this.promotionType = type;
        type === 'PROMOS' ? this.promos = true : this.promos = false;
        type === 'VOUCHERS' ? this.vouchers = true : this.vouchers = false;
    }

    onApplyClick(type, value) {

    }


    onApplyPromoCodeClick(type, value) {
        let serviceActiveId = this.webstorage.sessionSt_service_active_id;
        this.userServiceBase = this.webstorage.localSt_user_service_request;
        this.locationSelected = this.webstorage.sessionSt_location_selected;
        this.serviceType = this.webstorage.sessionSt_service_type;
        if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
            serviceActiveId = 1;
        }
        let userStoreIndex = -1;
        const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
            userStoreIndex = index;
            return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && !obj.serviceCompleted && obj.serviceType === this.serviceType;
        });
        this.userSelectedStore = selectedStore;
        this.userSelectedStore.storeCart.voucherAmount = 0;
        this.userSelectedStore.storeCart.voucher = null;
        this.promoCodeForm.controls['promocode'].setValue(value);
        if (this.promoCodeForm.invalid) {
            Object.keys(this.promoCodeForm.controls).forEach(key => {
                this.promoCodeForm.get(key).markAsDirty();
            });
            return;
        } else {
            this.promoError = '';
            let serviceActiveId = this.webstorage.sessionSt_service_active_id;
            if ((this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) || (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true)) {
                serviceActiveId = 1;
            }
            let userStoreIndex = -1;
            const selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
                userStoreIndex = index;
                return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.locationSelected.oocls_location_guid) && obj.serviceType === this.serviceType && !obj.serviceCompleted;
            });
            if (this.webstorage.sessionSt_weburl_order && this.webstorage.sessionSt_weburl_order === true) {
                selectedStore.serviceQRScanned = false;
            }
            this.userSelectedStore = selectedStore;
            let orderAmount = this.userSelectedStore.storeCart.orderTotal;
            const input = {
                oocv_ooc_guid: this.webstorage.localSt_user_id,
                oocv_code: value,
                order_amount: orderAmount,
                company_id: this.webstorage.sessionSt_location_selected.oocls_company_id,
                location_guid: this.webstorage.sessionSt_location_selected.oocls_location_guid,
                user_phone: this.cookie.cookie_user_phone,
                user_country_code: this.cookie.cookie_user_country_code,
                order_datetime: this.userSelectedStore.serviceDatetime
            };
            this.ecomservice.httpPost(EcomNetworkUtils.POST_ISVALID_VOUCHERCODE, input, '', true).subscribe((response) => {
                if (response.isSuccess) {
                    //$('.modal').css({"display": "none"});
                    let voucher = new VoucherBase();
                    voucher.voucher_guid = response.listValue.oocv_guid;
                    voucher.voucher_mod_guid = response.listValue.oocv_mod_guid;
                    voucher.voucher_amount = response.listValue.oocv_amount;
                    voucher.voucher_name = response.listValue.oocv_code;
                    voucher.voucher_type = response.listValue.voucher_type;
                    voucher.voucher_value_type = response.listValue.voucher_value_type;
                    voucher.voucher_max_percentage_amount = response.listValue.oomd_max_amount;
                    voucher.voucher_percentage = response.listValue.oomd_percentage;
                    voucher.voucher_min_order_amount = response.listValue.oomd_min_amount;
                    this.promoError = response.msg;
                    this.webstorage.sessionSt_voucher = voucher;
                    //redirect back to cart page
                    this.router.navigate(['cart', this.webstorage.sessionSt_company_clicked]);
                } else {
                    this.promoError = response.msg;
                }
            });
        }
    }



}